import { routerRender } from "./application/BaseApplication";
import { ViridisApp } from "./components/application/ViridisApp";

routerRender(ViridisApp);
